module.exports = __webpack_public_path__ + "static/media/tecni_azot.5dc5eb37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices/tecni_azot.jpg
// module id = 418
// module chunks = 0